<svg width="44" height="27" viewBox="0 0 326.1 199.81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M0,113.05h46.48v43.59H0v-43.59Z"/>
    <path fill="currentColor" d="M149.69,0h27.25v199.81h-27.25V0Z"/>
    <path fill="currentColor" d="M279.62,113.05h46.48v43.59h-46.48v-43.59Z"/>
</svg>
